// tslint:disable:max-line-length

import React from 'react';

export const DatatypeEmail = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,8c0-4.5,3.2-7.9,8-7.9c4.8,0,8,3.2,8,7.6c0,2.7-1.5,4.6-4,4.6c-1.6,0-2.4-0.7-2.7-1.8c-0.7,0.8-1.7,1.6-3.2,1.6 c-1.7,0-2.7-1.1-2.7-3.1c0-3.4,1.8-5.5,3.9-5.5c1.3,0,1.9,0.5,2.4,1l0.1-0.9h2.5l-1,6.1c-0.1,0.8,0.2,1.3,1.1,1.3 c1.3,0,2.2-1.2,2.2-3.2c0-3.7-2.6-6.3-6.5-6.3C4,1.5,1.5,4.2,1.5,8c0,3.8,2.4,6.6,6.4,6.6c1.5,0,2.8-0.3,3.8-1l0.7,1	c-1.2,0.8-2.9,1.3-4.7,1.3C3,15.8,0,12.6,0,8z M8.8,9.5l0.5-3.1C8.8,5.8,8.5,5.6,7.8,5.6c-1.3,0-2,1.6-2,3.2c0,1,0.3,1.5,1.3,1.5 C7.7,10.3,8.3,9.9,8.8,9.5z" />
    </svg>
  );
};
